var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 1H2.31348C2.56088 1 2.68458 1 2.78413 1.04524C2.87185 1.08511 2.94619 1.14922 2.99829 1.22995C3.0574 1.32154 3.07489 1.44332 3.10988 1.68686L3.58584 5M3.58584 5L4.64362 12.7314C4.77786 13.7125 4.84498 14.2031 5.08084 14.5723C5.28868 14.8977 5.58664 15.1564 5.93888 15.3174C6.33861 15.5 6.83647 15.5 7.83218 15.5H16.438C17.3859 15.5 17.8598 15.5 18.2471 15.3304C18.5886 15.1809 18.8815 14.9398 19.0931 14.6342C19.3331 14.2876 19.4218 13.8247 19.5991 12.8988L20.9302 5.94969C20.9926 5.62381 21.0238 5.46087 20.9786 5.3335C20.9389 5.22177 20.8606 5.12768 20.7576 5.06802C20.6403 5 20.4735 5 20.1399 5H3.58584ZM9.04483 20C9.04483 20.5523 8.59461 21 8.03923 21C7.48385 21 7.03362 20.5523 7.03362 20C7.03362 19.4477 7.48385 19 8.03923 19C8.59461 19 9.04483 19.4477 9.04483 20ZM17.0897 20C17.0897 20.5523 16.6394 21 16.0841 21C15.5287 21 15.0785 20.5523 15.0785 20C15.0785 19.4477 15.5287 19 16.0841 19C16.6394 19 17.0897 19.4477 17.0897 20Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartIcon);
export default __webpack_public_path__ + "static/media/cart-icon.4e6c933efe06255082dd6a51de10288c.svg";
export { ForwardRef as ReactComponent };